/* eslint-disable  */
import DefaultLayout from '##/Default';
import List from './List';
import TitleEmployees from './TitleEmployees';

const routes = [
    {
        path: '/titles',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'Job Titles'
    },
    
    {
        path: '/titles/:title_id/employees',
        exact: true,
        layout: DefaultLayout,
        component: TitleEmployees,
        auth: true,
        title: 'Titles Employees'
    }

];

export default routes;
